import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import './locales/i18n';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import AuthCallback from './components/AuthCallback';
import Landing from './pages/Landing';
import CompareCars from './pages/CompareCars';
import GetListed from './pages/GetListed';
import { HowWeWork, Privacy } from './pages/Legal';
import './index.css';

// Only the public CompareVIN site (home, compare-cars, legal pages) is live. The rest of the product
// (Dashboard, Analyze, AnalysisResult, History, Compare, SharedAnalysis, VinCheck,
// Navbar, ProtectedRoute) is disconnected here, not deleted — the page files and
// backend endpoints still exist if the AI-analyzer product comes back later.
function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/compare-cars" element={<CompareCars />} />
      <Route path="/how-we-work" element={<HowWeWork />} />
      <Route path="/get-listed" element={<GetListed />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function InnerApp() {
  const { isDark } = useTheme();

  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster
            position="top-right"
            toastOptions={{
              style: isDark ? {
                background: '#121212',
                color: '#FAFAFA',
                border: '1px solid #262626',
              } : {
                background: '#FFFFFF',
                color: '#141414',
                border: '1px solid #E5E5E5',
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <InnerApp />
      </div>
    </ThemeProvider>
  );
}

export default App;
